import React from "react";
import IntroductionContainer from "./index.css";

const Greeting = () => {
  return (
    <IntroductionContainer.GreetingDiv>
      <h1>인사말</h1>
      <div className="Greeting">
        <p>내가 가진 것을 나눈다는 것은 사회에 대한 배려입니다.</p>
        <span>
          누구나 자신만의 '재화', '달란트'(재능)를 갖고 있으며, 이를 필요로 하는
          타인이나 단체에 선물하는 것, 이것이 바로 재능기부입니다.
          <br />
          <br />
          성공한 CEO가 창업 멘토를 자처하거나, 문화 예술인들의 힐링 나눔, 자신의
          목소리를 기부하거나, 장소를 기부하거나, 혹은 기술을 기부하거나, 나아가
          헌혈을 하거나 어르신 안마를 해드리는 것 모두가 아름다운 재능기부의
          예입니다.
          <br />
          <br />
          한시적인 거창한 후원보다는 소박한 실천적 나눔의 특징을 갖는 것이
          재능기부(프로보노)이며, 이는 우리 생활 곳곳에서 쉽게 다가설 수 있는
          아름다운 기부의 새로운 패러다임입니다.
          <br />
          <br />
          중요한 것은 한 가지 재능을 나누는 것 보다, 다양한 재능을 함께
          엮어내었을 때 상상 할 수 없는 부가가치를 만들어 낼 수 있다는 것입니다.
          <br />
          <br />
          이 같은 취지를 실천하고자 ㈔한국재능기부협회는 다양한 재능기부
          참여자와 역량 있는 분들의 힘을 모아 사회 소외 계층에 대한 나눔 사업을
          실시하고 있습니다.
          <br />
          <br />한 분,한 분의 재능과 역량을 모아 21세기 대한민국의 새로운 복지
          문화를 만들어 가겠습니다.
        </span>
      </div>
    </IntroductionContainer.GreetingDiv>
  );
};

export default Greeting;
